import {
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { FilePlus2, Files, Plus, Upload } from "lucide-react";

interface MatterSubItemFileReferencesContextMenuProps {
  onCreateFileReferences: () => void;
  onOpenFileReferences: () => void;
  onUploadFileReference: () => void;
}

export const MatterSubItemFileReferencesContextMenu = ({
  onCreateFileReferences,
  onOpenFileReferences,
  onUploadFileReference,
}: MatterSubItemFileReferencesContextMenuProps) => {
  const { hasActionPermission } = useUser();
  const canCreateFileReferences = hasActionPermission(
    ACTION_PERMISSION_KEYS.matterFile,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <ContextMenuSub>
      <ContextMenuSubTrigger>
        <Files />
        File references
      </ContextMenuSubTrigger>
      <ContextMenuSubContent>
        <ContextMenuItem onSelect={onOpenFileReferences}>
          <FilePlus2 />
          Open file references
        </ContextMenuItem>
        {canCreateFileReferences ? (
          <>
            <ContextMenuItem onSelect={onCreateFileReferences}>
              <Plus />
              Create file reference
            </ContextMenuItem>
            <ContextMenuItem onSelect={onUploadFileReference}>
              <Upload />
              Upload file reference
            </ContextMenuItem>
          </>
        ) : null}
      </ContextMenuSubContent>
    </ContextMenuSub>
  );
};
